<p>
    <a [href]="other" class="downHyperlink">{{title}}</a>
    <span *ngIf="description !== ''">&nbsp;-&nbsp;{{description}}</span>
</p>
